import {VueConstructor} from 'vue';
import LocationSegment from './LocationSegment.vue';
import ParametersSegment from './ParameterSegment.vue';
import Segment from './Segment';

export {
    LocationSegment,
    ParametersSegment,
    Segment,
};

export interface SegmentConfiguration {
    label: string;
    component: VueConstructor;
    props: object;
    path: string;
}
